<template>
  <v-layout row wrap white pt-4 justify-left align-end>
    <v-flex xs3 ml-0>
      <v-menu
        v-model="reportEndDateMenu"
        :close-on-content-click="true"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            clearable
            v-model="reportEndDateFormated"
            label="Data de referência"
            return-masked-value
            mask="##/####"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          type="month"
          no-title
          v-model="formData.date_end_field"
          @input="reportDateMenu = false"
        ></v-date-picker>
      </v-menu>
    </v-flex>

    <v-flex xs6 px-3>
      <v-autocomplete
        ref="condominiumCbo"
        clearable
        v-model="formData.condominium_id"
        :items="condominiums"
        item-text="name_fantasy"
        item-value="condominium_id"
        label="Selecione o condomínio"
        chips
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
          >
            <v-avatar>
              <img :src="data.item.avatar" />
            </v-avatar>
            {{ data.item.name_fantasy }}
          </v-chip>
        </template>

        <template v-slot:item="data">
          <template v-if="checkType(data)">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <img :src="data.item.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name_fantasy"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.name_company"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-autocomplete>
    </v-flex>

    <v-flex xs2 pb-3 pt-2 pr-0>
      <v-btn color="blue-grey" class="white--text" @click="search(0)">
        Gerar
        <v-icon right dark>cached</v-icon>
      </v-btn>
    </v-flex>

    <v-flex xs1 pb-3 class="pt-1" style="max-width: 60px">
      <v-btn fab dark small color="blue-grey" class="mt-2" @click="search(1)">
        <v-icon v-if="!pdfRun" dark>picture_as_pdf</v-icon>
        <v-progress-circular
          style="height: 16px; width=16px;"
          v-if="pdfRun"
          :width="3"
          color="white"
          indeterminate
        ></v-progress-circular>
        <!-- <v-icon v-if="!pdfRun" dark class="icn-spinner">replay</v-icon> -->
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import * as moment from 'moment'

export default {
  name: 'DocReportFiltersDash',

  props: {
    getContractStatus: Function,
    changeTitle: Function,
    getAccountabilityData: Function
  },

  data () {
    return {
      pdfRun: false,
      reportDateMenu: false,
      reportEndDateMenu: false,
      condominiums: [],
      formData: {
        condominium_id: '',
        date_init: '',
        date_end_field: ''
      }
    }
  },

  mounted () {
    this.getComdominiums()
  },

  computed: {
    reportDateFormated: {
      get () {
        return this.formData.date_init
          ? moment(this.formData.date_init).format('MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          this.formData.date_init = moment(value).format('MM/YYYY')
        } else {
          this.formData.date_init = ''
        }
      }
    },

    reportEndDateFormated: {
      get () {
        return this.formData.date_end_field
          ? moment(this.formData.date_end_field).format('MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 7) return
          console.log(`${value.split('/')[0]}/${value}`)
          this.formData.date_end_field = moment(
            `${value.split('/')[0]}/${value}`
          ).format('YYYY-MM')
        } else {
          this.formData.date_end_field = ''
        }
      }
    }
  },

  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    },

    changeTitleSelCondominium (id) {
      let txt
      var index = this.condominiums.findIndex(
        (condominium) => condominium.condominium_id === id
      )

      this.$store.commit('docsReports/updateSearchData', {
        condominiumName: this.condominiums[index].name_fantasy
      })

      txt =
        index > -1
          ? `Condomínio ${this.condominiums[index].name_fantasy}`
          : 'Todos os condomínios'
      this.changeTitle(txt)
    },

    getComdominiums () {
      let obj = {
        url: '/api/get_list',
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.condominiums = response.data
        let obj = { condominiums: response.data }
        this.$store.commit('condominiums/updateCondominiumList', obj)
        this.$props.condominiums = response.data
      })
    },

    generatePdf (data) {
      this.pdfRun = true
      let query = {
        condominium_id: data.condominium_id,
        date_end: data.date_end
      }
      console.log('dash - ', data)
      let obj = {
        url: '/api/report_documents',
        query: query,
        method: 'post',
        noLoader: true,
        returnError: true
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.pdfRun = false
        // console.log(response.data.file);
        if (!response.data) {
          let obj = {
            message:
              'Não foi possível gerar o PDF, tente novamente mais tarde!',
            title: 'Ops!',
            callback: (_) => {},
            type: 'warning',
            btConfirm: { name: 'Sim', show: false },
            btCancel: { name: 'Ok', show: true }
          }
          this.$store.commit('confirmMessage/showConfirmMessage', obj)
          return
        }

        window.open(`${response.data.file}`)
      })
    },

    search (pdf) {
      this.$store.dispatch('docsReports/resetCompletDocList')
      // this.$store.state.docsReports.completDocList;
      let lastDay = moment(this.formData.date_end_field).daysInMonth()

      this.formData.date_end = this.formData.date_end_field
        ? `${this.formData.date_end_field}-${lastDay}`
        : ''

      this.formData.reportDate = this.reportDateFormated

      this.getAccountabilityData(this.formData)
      this.changeTitleSelCondominium(this.formData.condominium_id)

      this.getContractStatus(this.formData, this.$refs.condominiumCbo).then(
        (stop) => {
          if (pdf && !stop) {
            this.generatePdf(this.formData)
          }
        }
      )
    }
  }
}
</script>

<style>
.icn-spinner {
  animation: spin-animation 0.5s infinite;
  display: inline-block;
}

@keyframes spin-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
</style>
